export default __webpack_public_path__ + "static/media/ECE-graf-PLA-FIX-cat--4.f75b8075.png";